// client/customer/src/utils/reservation/by-Date/fetchOpenDatesForStore.ts
import apiConfig from '../../../apiConfig';

export type OpenDate = {
  date: string;    // 'YYYY-MM-DD'
  is_open: boolean;
};

export const fetchOpenDatesForStore = async (
  storeId: number,
  days: number = 30
): Promise<OpenDate[]> => {
  const params = new URLSearchParams({
    store_id: String(storeId),
    days: String(days),
  });

  const res = await fetch(
    `${apiConfig.baseURL}/api/customer-app/reservation/by-date/open-dates?${params.toString()}`
  );

  if (!res.ok) {
    throw new Error('Failed to fetch open dates');
  }

  const data = await res.json() as { dates: OpenDate[] };
  return data.dates;
};
